import { FrontendApplication, FrontendApplicationContribution, WidgetManager } from '@theia/core/lib/browser';
import { Widget } from '@theia/core/lib/browser/widgets/widget';
import { inject, injectable } from '@theia/core/shared/inversify';
import { OnlinePreviewHostWidget } from './online-preview-host-widget';

@injectable()
export class OnlinePreviewHostContribution implements FrontendApplicationContribution {
    @inject(WidgetManager)
    protected readonly widgetManager!: WidgetManager;

    async onStart(_app: FrontendApplication): Promise<void> {
        const widget: OnlinePreviewHostWidget = await this.widgetManager.getOrCreateWidget(OnlinePreviewHostWidget.ID);
        if (!widget.isAttached) Widget.attach(widget, document.body);
    }
}
